import { getFirebaseAuth } from '@/lib/firebase';
import type { SnapshotMetadata } from 'firebase/firestore';

/** Skip live org updates from cache or after account/org switch. */
export function shouldSkipOrgLiveUpdate(
  metadata: SnapshotMetadata,
  expectedUid: string,
  expectedOrgId: string,
  activeOrgId?: string | null
): boolean {
  if (metadata.fromCache) return true;
  if (getFirebaseAuth().currentUser?.uid !== expectedUid) return true;
  if (activeOrgId != null && expectedOrgId !== activeOrgId) return true;
  return false;
}
